//@ts-check
import { useQuery } from '@tanstack/react-query';

import getExchangeUiStaticData from '../../actions/get-exchange-ui-static-data';

/** @param {import('@tanstack/react-query').UseQueryOptions} [options] */
const useExchangeUiStaticData = (options = {}) => {
  /** @type {import('@action-types/exchange-ui').ExchangeUiQueryState} */
  const data = useQuery({
    ...options,
    queryKey: ['get-exchange-ui-static-data'],
    enabled: options.enabled ?? true,
    queryFn: async ({ signal }) => getExchangeUiStaticData({ signal }),
    staleTime: Infinity,
  });

  return data;
};

export default useExchangeUiStaticData;
